import {RouteRecordRaw} from "vue-router";
import IconsPage from "@/modules/vue/pages/IconsPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    name: 'debug.icons',
    path: '/debug/icons',
    component: IconsPage,
  },
];